import React from 'react'
import Stack from '@mui/material/Stack'

import Link from '~/client/components/Link'
import AppIcon from '~/client/components/AppIcon'

export default function AppIconAndName({ app, to = `/apps/${app.host}` }){
  return <Stack
    direction="row"
    alignItems="center"
    spacing={2}
    component={Link}
    to={to}
  >
    <AppIcon {...{ app }}/>
    <div>{app.name ?? app.host}</div>
  </Stack>
}
